export default __webpack_public_path__ + "static/media/DNo.27-0.5b1a5edf.jpg";